module.exports = __webpack_public_path__ + "static/pic06-c62f5a8cf25a22928a657ef8c92a8e4e.jpg";